// Re-export client and types from modular files
export { supabase } from './supabase-client'
export type * from './supabase-types'

// Re-export all API modules from lib/api/ for backward compatibility
// New code should import directly from '@/lib/api/<module>' for better tree-shaking
export {
  soundsApi,
  teslaModelsApi,
  collectionsApi,
  submissionsApi,
  storageApi,
  trendingApi,
  SupabaseError,
  withRetry
} from './api'

export { LIST_COLUMNS } from './api/sounds'
